<div class="popup-form team-popup">
    <form [formGroup]="teamForm" (ngSubmit)="onSubmit()">
        <div class="box-wrap">
            <div class="row">
                <div class="col-sm-6 col-6 input-login">
                    <input type="text" (blur)="Address = trimming_fn(Address)" required
                        class="border-input" maxlength="50" formControlName="teamName" data-testid="addteam-team-input"
                        [ngClass]="{ 'is-invalid': submitted && Teamgetter['teamName'].errors }" />
                    <label>Team name</label>
                    <div *ngIf="submitted && Teamgetter['teamName'].errors" class="invalid-feedback">
                    </div>
                </div>
                <div class="col-md-6 col-6">
                    <mat-label class="label-mat-font-size">Available report type</mat-label>
                    <mat-select data-testid="add-team-member-select" id="availableReportTypesSelect" #availableReportTypes
                        [ngClass]="{ 'is-invalid': submitted && Reportgetter['stReportTypes'].errors,
                             'border-line': submitted && Reportgetter['stReportTypes'].errors
                         }"
                        panelClass="mat-select-panel-wrap team-member-select-box" multiple
                        class="border-input sel-mat-inp select val-line"placeholder="Select available report type"                      
                        [formControl]="selectedOptionsReportTypes" [value]="selectedReportTypes" (click)="availableReportTypes.open()">

                        <!-- Search Input -->
                        <!--  <mat-option class="mat-search-option" id="search-option" disabled>
                            <input id="searchTeamMemberInput" matInput placeholder="Search available report"
                                autocomplete="off" (keyup)="filterReportTypes($event)"
                                class="mat-select-search-input" />
                        </mat-option> -->
                          <!-- Filtered Options -->
                        <ng-container *ngFor="let report of filteredReportTypes">
                            <mat-option *ngIf="isReportAvailable(report.value)"
                                [value]="report.value">
                                {{ report.label }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                      <div *ngIf="submitted && Teamgetter['stReportTypes'].errors" class="invalid-feedback">
                       <div *ngIf="Teamgetter['stReportTypes'].errors['required']" class="invalid-margintop">
                       </div>
                   </div>
               </div>
                <div class="col-sm-6 col-6 input-login-email">
                        <input type="text"
                            class="border-input val-line address-textarea" formControlName="address"
                            data-testid="addteam-address-input"
                            (blur)="onBlurControl('address')"
                            [ngClass]="{ 'is-invalid': submitted && Teamgetter['address'].errors, 'filled': teamForm.get('address')?.value || teamForm.get('address')?.touched  }" 
                            (focus)="getControl('address')?.markAsTouched()" />
                        <label>Address</label>
                        <div *ngIf="submitted && Teamgetter['address'].errors" class="invalid-feedback">
                        </div>
                </div>
                 <div class="col-md-6 col-6">
                    <label>Default report type</label>
                   <select formControlName="inReportType" class="border-input sel-mat-inp select val-line select-placeholder-dropdown select-box defaultReportClass" data-testid="addteam-report-select"
                       [ngClass]="{ 'is-invalid': submitted && Teamgetter['inReportType'].errors }">
                       <option value="" disabled selected > Select default report type</option>
                       <!-- <option *ngFor="let report of reportTypes" [value]="report.value">{{ report.label }}</option> -->
                          <option *ngFor="let report of selectedAvailableReports" 
                                [value]="report.value">
                        {{ report.label }}
                        </option>
                   </select>
                   <div *ngIf="submitted && Teamgetter['inReportType'].errors" class="invalid-feedback">
                       <div *ngIf="Teamgetter['inReportType'].errors['required']" class="invalid-margintop">
                       </div>
                   </div>
               </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-6 input-login-email">
                    <input type="text" class="border-input val-line position-relative" formControlName="email"
                        readonly
                        [ngClass]="{ 'is-invalid': submitted && Teamgetter['email'].errors, 'filled': teamForm.get('email')?.value, 'ellipsis-input': multipleInvoiceEmailData.length > 0 }"
                        data-testid="addteam-email-input" />
                    <span class="plus-icon-claim icon-cursor" (click)="showMultipleInvoiceEmailModal(multipleInvoiceEmail)">
                        <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z" fill="#6452C5" />
                        </svg>
                    </span>
                    <label>Invoice email
                        <i class="fa fa-info-circle injury-date popover-icon" placement="top"
                        [ngbPopover]="teamContent" [popoverClass]="isInputFocused ? 'volumePopover widthPopover focused' : 'volumePopover widthPopover'" triggers="mouseenter:mouseleave"></i>
                    </label>
                    <ng-template #teamContent>
                        <div>
                            Invoice email will be sent to the provided email
                        </div>
                    </ng-template>
                    <div *ngIf="submitted && Teamgetter['email'].errors" class="err-mt invalid-margintop">
                    </div>
                </div>
                <div class="col-sm-6 col-6 input-login-email">
                    <input type="text"
                        class="border-input position-relative"
                        formControlName="reportEmail"
                        readonly
                        [ngClass]="{ 'is-invalid': submitted && Teamgetter['reportEmail'].errors, 'filled': teamForm.get('reportEmail')?.value, 'ellipsis-input': multipleReportEmailData.length > 0 }"
                        data-testid="addteam-report-email-input" />
                    <span class="plus-icon-claim icon-cursor" (click)="showMultipleReportEmailModal(multipleReportEmail)">
                        <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z" fill="#6452C5" />
                        </svg>
                    </span>
                    <label>Report email
                        <i class="fa fa-info-circle injury-date popover-icon" placement="top"
                        [ngbPopover]="teamContentreport" [popoverClass]="isInputFocused ? 'volumePopover widthPopover focused' : 'volumePopover widthPopover'" triggers="mouseenter:mouseleave"></i>
                    </label>
                    <ng-template #teamContentreport>
                        <div>
                            Report ready email will be sent to the provided email
                        </div>
                    </ng-template>
                    <div *ngIf="submitted && Teamgetter['reportEmail'].errors" class="err-mt invalid-margintop">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-6 input-login">
                    <mat-label class="label-mat-font-size">Team member</mat-label>

                    <mat-select data-testid="add-team-member-select" id="teamMemberSelect" #selectTeamMember
                        [ngClass]="{ 'is-invalid': submitted && Teamgetter['teamMember'].errors }"
                        panelClass="mat-select-panel-wrap team-member-select-box" multiple
                        class="sel-mat-inp select border-input val-line" placeholder="Select team member"
                        [formControl]="selectedOptions" [value]="selectedTeamMembers" (click)="selectTeamMember.open()">

                        <!-- Search Input -->
                        <mat-option class="mat-search-option" id="search-option" disabled>
                            <input id="searchTeamMemberInput" matInput placeholder="Search team member"
                                autocomplete="off" (keyup)="filterTeamMemberInfo($event)"
                                class="mat-select-search-input" />
                        </mat-option>

                        <!-- Filtered Options -->
                        <ng-container *ngFor="let teamMember of filteredTeamMembers">
                            <mat-option [hidden]="!teamMember.isShow" (click)="toggleOption(teamMember.teamMemberId)"
                                [value]="teamMember.teamMemberId">
                                {{ teamMember.teamMemberName }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </div>
                <div class="col-sm-6 col-6 input-login-email">
                    <input _ngcontent-iam-c175="" type="text"  formControlName="faxnumber"
                    (keypress)="keyPress($event)"
                    (blur)="onBlurControl('faxnumber')"
                    class="border-input val-line" data-testid="addteam-faxnumber-input"
                    [ngClass]="{
                        'is-invalid': (faxnumberInvalidate) || (submitted && Teamgetter['faxnumber'].hasError('pattern')),
                        'filled': teamForm.get('faxnumber')?.value || teamForm.get('faxnumber')?.touched
                      }"
                    (focus)="getControl('faxnumber')?.markAsTouched()" 
                    mask="(000) 000-0000">
                    <label>Fax number</label>
                    <!-- <input type="text"  class="border-input val-line" formControlName="faxnumber" (keypress)="keyPress($event)"
                        [ngClass]="{ 'is-invalid': submitted && Teamgetter['faxnumber'].errors }" data-testid="addteam-faxnumber-input"/>
                    <label>FAX number</label> -->
                    <div *ngIf="submitted && Teamgetter['faxnumber'].errors" class="err-mt invalid-margintop">
                    </div>
                </div>

               
                    <div class="col-md-6 col-6">
                         <label>Priority</label> 
                        <select formControlName="inPriority" class="select-box border-input sel-mat-inp select val-line select-placeholder-dropdown" data-testid="addteam-report-select"
                            [ngClass]="{ 'is-invalid': submitted && Teamgetter['inPriority'].errors }">
                            <option hidden  value=""  disabled selected > Select priority</option>
                            <option *ngFor="let priority of priorityTypes" [value]="priority.value">{{ priority.label }}</option>
                        </select>
                        <div *ngIf="submitted && Teamgetter['inPriority'].errors" class="invalid-feedback">
                            <div *ngIf="Teamgetter['inPriority'].errors['required']" class="invalid-margintop">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-6">
                        <label>Turnaround time</label>
                        <select formControlName="inTurnaroundTime" class="select-box border-input sel-mat-inp select val-line select-placeholder-dropdown" data-testid="addteam-report-select"
                            [ngClass]="{ 'is-invalid': submitted && Teamgetter['inTurnaroundTime'].errors }">
                            <option hidden  value="" disabled selected> Select turnaround time</option>
                            <option *ngFor="let turnaround of turnaroundTimeTypes" [value]="turnaround.value">{{ turnaround.label }}</option>
                        </select>
                        <div *ngIf="submitted && Teamgetter['inTurnaroundTime'].errors" class="invalid-feedback">
                            <div *ngIf="Teamgetter['inTurnaroundTime'].errors['required']" class="invalid-margintop">
                            </div>
                        </div>
                    </div>
            </div>
            
        </div>
        <div class="box-wrap mt-4">
            <div class="row d-flex justify-content-between align-items-center div-margin-bottom">
                <div class="col-md-6 col-sm-6 d-flex justify-content-between">
                    <label class="tpa-label toggle-label tgl-lbl-width">TPA</label>
                    <div class="checkout">
                        <input class="form-check-input" formControlName="isTPARequired" type="checkbox"
                            data-testid="addteam-TPA-required-input">
                        <div class="checkout-box"></div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 d-flex justify-content-between">
                    <label class="tpa-label toggle-label tgl-lbl-width">Email on publish</label>
                    <div class="checkout">
                        <input class="form-check-input" formControlName="flgIsEmailOnPublish" type="checkbox"
                            data-testid="addteam-email-on-publish-input">
                        <div class="checkout-box"></div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 d-flex">
                    <!-- <label class="tpa-label toggle-label">Receive invoice via fax
                        <i class="fa fa-info-circle popover-icon popover-tpa-i" placement="top"
                                [ngbPopover]="faxContent"
                                 [popoverClass]="isInputFocused ? 'volumePopover widthPopover focused' : 'volumePopover widthPopover'" 
                                 triggers="mouseenter:mouseleave"></i>
                             <ng-template #faxContent>
                                 <div>
                                    Enabling fax will not send invoice email
                                 </div>
                             </ng-template>
                    </label>
                    <div class="checkout" style="margin-left: 15px;">
                        <input class="form-check-input" formControlName="isTPARequired" type="checkbox"
                            data-testid="addteam-fax-input">
                        <div class="checkout-box"></div>
                    </div> -->
                </div>
        </div>
        </div>
        <div class="btn-box pdgtb">
            <button class="btn-wrap" data-testid="addteam-submit-button">
                {{buttonname}}
            </button>
        </div>
    </form>
</div>

<!-- Modal - Multiple Invoice Email -->
<ng-template #multipleInvoiceEmail let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Invoice email</h5>
        <button type="button" class="close close-icon" aria-label="Close"
            (click)="modal.dismiss('Cross click'); closeInvoiceEmailModal()"
            data-testid="addteam-multiple-invoice-email-close-button">
            <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
        </button>
    </div>
    <div class="modal-body modal-background">
        <div class="popup-form">
            <form [formGroup]="multipleInvoiceEmailForm">
                <div>
                    <div class="box-wrap not-selectable">
                        <div class="row">
                            <div class="col-sm-12 col-12 input-login">
                                <input autocomplete="off" type="text" formControlName="email"
                                    #invoiceEmailInput maxlength="32"
                                    [ngClass]="{ 'is-invalid': (multiInvoiceEmailFormSubmit && multipleInvoiceEmailForm.get('email')?.errors) || showInvoiceEmailMessage }"
                                    class="border-input ng-pristine ng-touched position-relative modal-color val-css"
                                    data-testid="addteam-multiple-invoice-email-input"
                                    (keypress)="keyPress($event)"
                                    (keyup)="checkDuplicateInvoiceEmail(invoiceEmailInput.value)"
                                    (keydown.enter)="addMultipleInvoiceEmail()" />
                                <span class="plus-icon-claim icon-cursor" (click)="addMultipleInvoiceEmail()">
                                    <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z" fill="#6452C5" />
                                    </svg>
                                </span>
                                <label class="label modal-color">Invoice email</label>

                                <div class="alignment-list" *ngFor="let emailItem of multipleInvoiceEmailData; index as i">
                                    <div class="chip">
                                        <div class="chip-content modal-color">{{ emailItem }}</div>
                                        <div class="chip-close icon-cursor" (click)="removeInvoiceEmail(i)"
                                            data-testid="addteam-multiple-invoice-email-remove-button">
                                            <svg width="15" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1"
                                                viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <path
                                                    d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                                                    fill="#d94d51" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-box pdgtb">
                    <button type="button" class="btn-wrap red-btn CancelBox modal-color"
                        (click)="modal.dismiss('Cross click'); closeInvoiceEmailModal()"
                        data-testid="addteam-multiple-invoice-email-cancel-button">
                        Cancel
                    </button>&nbsp;
                    <button type="button" class="btn-wrap CancelBox modal-color" (click)="saveInvoiceEmails()"
                        data-testid="addteam-multiple-invoice-email-save-button">
                        Save
                    </button>&nbsp;
                </div>
            </form>
        </div>
    </div>
</ng-template>

<!-- Modal - Multiple Report Email -->
<ng-template #multipleReportEmail let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Report email</h5>
        <button type="button" class="close close-icon" aria-label="Close"
            (click)="modal.dismiss('Cross click'); closeReportEmailModal()"
            data-testid="addteam-multiple-report-email-close-button">
            <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
        </button>
    </div>
    <div class="modal-body modal-background">
        <div class="popup-form">
            <form [formGroup]="multipleReportEmailForm">
                <div>
                    <div class="box-wrap not-selectable">
                        <div class="row">
                            <div class="col-sm-12 col-12 input-login">
                                <input autocomplete="off" type="text" formControlName="email"
                                    #reportEmailModalInput maxlength="32"
                                    [ngClass]="{ 'is-invalid': (multiReportEmailFormSubmit && multipleReportEmailForm.get('email')?.errors) || showReportEmailMessage }"
                                    class="border-input ng-pristine ng-touched position-relative modal-color val-css"
                                    data-testid="addteam-multiple-report-email-input"
                                    (keypress)="keyPress($event)"
                                    (keyup)="checkDuplicateReportEmail(reportEmailModalInput.value)"
                                    (keydown.enter)="addMultipleReportEmail()" />
                                <span class="plus-icon-claim icon-cursor" (click)="addMultipleReportEmail()">
                                    <svg width="15" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 12.4667H12.4667V22H9.53333V12.4667H0V9.53333H9.53333V0H12.4667V9.53333H22V12.4667Z" fill="#6452C5" />
                                    </svg>
                                </span>
                                <label class="label modal-color">Report email</label>

                                <div class="alignment-list" *ngFor="let emailItem of multipleReportEmailData; index as i">
                                    <div class="chip">
                                        <div class="chip-content modal-color">{{ emailItem }}</div>
                                        <div class="chip-close icon-cursor" (click)="removeReportEmail(i)"
                                            data-testid="addteam-multiple-report-email-remove-button">
                                            <svg width="15" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1"
                                                viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <path
                                                    d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                                                    fill="#d94d51" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn-box pdgtb">
                    <button type="button" class="btn-wrap red-btn CancelBox modal-color"
                        (click)="modal.dismiss('Cross click'); closeReportEmailModal()"
                        data-testid="addteam-multiple-report-email-cancel-button">
                        Cancel
                    </button>&nbsp;
                    <button type="button" class="btn-wrap CancelBox modal-color" (click)="saveReportEmails()"
                        data-testid="addteam-multiple-report-email-save-button">
                        Save
                    </button>&nbsp;
                </div>
            </form>
        </div>
    </div>
</ng-template>